import { memo } from 'react';
import { useTranslation } from 'next-i18next';

import { BoltIcon } from '@heroicons/react/24/outline';
import { cn, useResponsiveBreakPoints } from '@restworld/utils-common';
import { ManOnComputerIllustration } from '@restworld/utils-common/illustrations/man-on-computer';
import { Heading } from '@restworld/ui-ds-base';

import { TitleWithBackBtn } from '.';

export const ApplicationWizardUI = memo(({ hideBackBtn }: { hideBackBtn?: boolean }) => {
  const { isDesktop } = useResponsiveBreakPoints();
  const { t } = useTranslation();
  return (
    <Wrapper>
      <TitleWithBackBtn title={t('onboarding-page:apply_via_questionnaire')} hideBackBtn={hideBackBtn} />
      <span className="flex flex-row items-center gap-1.5 justify-center">
        <BoltIcon className="h-4" />
        <Heading color="muted" weight="light">
          {t('onboarding-page:it_will_take_about5_minutes')}
        </Heading>
      </span>
      <ManOnComputerIllustration
        className="self-center"
        {...(isDesktop ? { width: 340, height: 315 } : { width: 280, height: 265 })}
      />
    </Wrapper>
  );
});
const Wrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex flex-col gap-4', className)} {...props} />
);
